import { Box, Flex, HStack, Link, Text } from '@chakra-ui/react';
import { IconMaintenance } from 'central-icons/IconMaintenance';

interface SkillsSectionProps {
  skills: string[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

export const SkillsSection = ({
  skills,
  isExpanded,
  onToggleExpanded,
}: SkillsSectionProps) => {
  if (!skills.length) return null;

  const displaySkills = isExpanded ? skills : skills.slice(0, 5);

  return (
    <Flex gap={2} fontSize="sm" align="start" color="text.primary">
      <Box flexShrink={0} mt="4px">
        <IconMaintenance size={16} />
      </Box>
      <HStack spacing={1} flexWrap="wrap">
        <Text>{displaySkills.join(', ')}</Text>
        {skills.length > 5 && (
          <Link
            color="lightBlue.600"
            fontSize="xs"
            fontWeight="600"
            textDecoration="underline"
            ml={1}
            onClick={(e) => {
              e.stopPropagation();
              onToggleExpanded();
            }}
            cursor="pointer"
          >
            {isExpanded ? 'Show Less' : 'More'}
          </Link>
        )}
      </HStack>
    </Flex>
  );
};
